import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiFileText, FiMail, FiPhone } = FiIcons;

const TermsPage = () => {
  return (
    <div className="terms-page min-h-screen bg-gray-50">
      {/* Header */}
      <section className="hero-gradient text-white py-16">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <div className="flex items-center justify-center gap-3 mb-6">
              <SafeIcon icon={FiFileText} className="text-4xl" />
              <h1 className="text-4xl lg:text-5xl font-bold">תנאי שימוש</h1>
            </div>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              תנאי השימוש בשירותי BOTLEY ובפלטפורמת סוכני ה-AI
            </p>
            <p className="text-lg text-gray-300 mt-4">עודכן לאחרונה: ספטמבר 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-2xl shadow-lg p-8 lg:p-12"
          >
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-8">
              
              <div>
                <p className="text-lg font-medium mb-4">
                  ברוכים הבאים ל־BOTLEY (להלן: "החברה", "BOTLEY" או "השירות"). השימוש באתר, במערכות ובשירותים של BOTLEY כפוף לתנאי שימוש אלו.
                </p>
                <p className="font-semibold text-purple-700">
                  גלישה באתר, יצירת חשבון, התקנה או שימוש בשירותים מהווים הסכמה מלאה, מדעת וללא תנאי לתנאים. אם אינך מסכים/מה – הימנע/י משימוש.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-200">
                <h3 className="text-xl font-bold text-blue-800 mb-3">שאלות לגבי תנאי השימוש?</h3>
                <p className="text-blue-700">
                  פנו אלינו: info@botley.co.il | privacy@botley.co.il
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">פרטי קשר</h2>
                <p className="mb-4">הודעות לחברה תישלחנה לכתובות:</p>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <SafeIcon icon={FiMail} className="text-purple-600" />
                    <span>דוא״ל כללי: info@botley.co.il</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <SafeIcon icon={FiMail} className="text-purple-600" />
                    <span>פרטיות/DPO: privacy@botley.co.il</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <SafeIcon icon={FiPhone} className="text-purple-600" />
                    <span>טלפון: 054-7805152</span>
                  </div>
                </div>
              </div>

            </div>
          </motion.div>
        </div>
      </section>

      {/* Back to Home */}
      <section className="py-12 bg-white">
        <div className="container text-center">
          <a 
            href="#/"
            className="inline-flex items-center gap-3 text-purple-600 hover:text-purple-700 font-semibold text-lg transition-colors"
          >
            <SafeIcon icon={FiArrowRight} />
            חזרה לעמוד הבית
          </a>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;